import { data } from "jquery";

export const API_ENDPOINTS = {
  PMS: {
    ADD_SELF_ASSESSMENT: (checkWeightage) =>
      `pms?checkWeightage=${checkWeightage}`,
    MYSELF_YEAR_DROPDOWN: () => "pms/myself/dropdown",
    FETCH_PMS: () => `pms/pms-login`,
    FETCH_EMP_DATA: () => `pms/fetch-pms-by-level`,
    FETCH_EMP_INFO: () => `pms/pms-empInfo`,
    FETCH_LTIP: (pmsYear, year) =>
      `/pms/fetchWithEmpId?pmsYear=${pmsYear}&year=${year}`,
    FETCH_EMP_LETTER: (pmsYear) =>
      `/pms/myself/letterPreview?pmsYear=${pmsYear}`,
    FETCH_EMP_LTIP_LETTER: (pmsYear) => `/pms/ltip-letter?pmsYear=${pmsYear}`,
    LTIP_PMSYEARS: () => `/pms/fetch-ltip-year-dropdown`,
    ADD_FEEDBACK: () => `/pms/employee-feedback`,
    DH_BUDGET: (pmsYear, dhId, empId) =>
      `/pmsDHTargetMaster/getSelfList?pmsYear=${pmsYear}&dhId=${dhId}&empId=${empId}`,
    BH_EXPORT: (filterData) => {
      const queryParams = new URLSearchParams();
      if (filterData.divisionheadid)
        queryParams.append("divisionHeadId", filterData.divisionheadid);
      if (filterData.reviewerId)
        queryParams.append("reviewerId", filterData.reviewerId);
      if (filterData.reportingmanagerid)
        queryParams.append("reportingManagerId", filterData.reportingmanagerid);
      if (filterData.grade) queryParams.append("grade", filterData.grade);
      const queryString = queryParams.toString();
      return queryString
        ? `/pms/HR/export/excelBH/byFilter?${queryString}`
        : `/pms/HR/export/excelBH/byFilter`;
    },

    DH_EXPORT: (filterData) =>
      `/pms/HR/exportdivisionHeadExport/excelofdivisionhead/byFilter?reviewerId=${filterData.reviewerId}&reportingManagerId=${filterData.reportingmanagerid}`,
    BH_CHART: (filterData) =>
      `/pms/HR/analytics/division-head-chart?pmsYear=${filterData.pmsYear}${filterData.divisionheadid ? `&divHeadId=${filterData.divisionheadid}` : ""}`,

    PMS_DROPDOWN: (
      level,
      repManId,
      reviewerId,
      pmsYear,
      status,
      promotion,
      roleOfIntake,
    ) => {
      const queryParams = new URLSearchParams();
      if (level) queryParams.append("level", level);
      if (repManId) queryParams.append("repManId", repManId);
      if (reviewerId) queryParams.append("reviewerId", reviewerId);
      if (pmsYear) queryParams.append("pmsYear", pmsYear);
      if (status) queryParams.append("status", status);
      if (promotion) queryParams.append("promotion", promotion);
      if (roleOfIntake) queryParams.append("roleOfIntake", roleOfIntake);

      const queryString = queryParams.toString();
      return queryString ? `/pms/dropdown?${queryString}` : `/pms/dropdown`;
    },
    FEEDBACK_QUESTION: () => `/pms/getFeedbackQuestions`,
    PMS_LIST: (
      level,
      repManId,
      reviewerId,
      empId,
      manPower,
      pmsYear,
      roleOfIntake,
      pageNo,
      pageSize,
      status,
      promotion,
    ) => {
      const queryParams = new URLSearchParams();
      if (level) queryParams.append("level", level);
      if (repManId) queryParams.append("repManId", repManId);
      if (reviewerId) queryParams.append("reviewerId", reviewerId);
      if (empId) queryParams.append("empId", empId);
      if (manPower) queryParams.append("manPower", manPower);
      if (pmsYear) queryParams.append("pmsYear", pmsYear);
      if (roleOfIntake) queryParams.append("roleOfIntake", roleOfIntake);
      if (pageNo) queryParams.append("pageNo", pageNo);
      if (pageSize) queryParams.append("pageSize", pageSize);
      if (status) queryParams.append("status", status);
      if (promotion) queryParams.append("promotion", promotion);

      const queryString = queryParams.toString();
      return queryString ? `/pms/list?${queryString}` : `/pms/list`;
    },
    PMS_ANALYTICS_CHART: (levelName, pmsYear) => {
      const queryParams = new URLSearchParams();
      if (levelName) queryParams.append("levelName", levelName);
      if (pmsYear) queryParams.append("pmsYear", pmsYear);
      const queryString = queryParams.toString();
      return queryString
        ? `/pms/pms-analytics-chart?${queryString}`
        : `/pms/pms-analytics-chart`;
    },
    PMS_REVIEWER_DIVISION_CHART: (levelName, pmsYear, repManId, reviewerId) => {
      const queryParams = new URLSearchParams();
      if (levelName) queryParams.append("levelName", levelName);
      if (pmsYear) queryParams.append("pmsYear", pmsYear);
      if (repManId) queryParams.append("repManId", repManId);
      if (reviewerId) queryParams.append("reviewerId", reviewerId);
      const queryString = queryParams.toString();
      return queryString
        ? `/pms/chart/rev-dh-chart?${queryString}`
        : `/pms/chart/rev-dh-chart`;
    },
    PMS_RM_ANALYTICS_CHART: (pmsYear) => {
      const queryParams = new URLSearchParams();
      if (pmsYear) queryParams.append("pmsYear", pmsYear);
      const queryString = queryParams.toString();
      return queryString
        ? `/pms/chart/rm-analytic-chart?${queryString}`
        : `/pms/chart/rm-analytic-chart`;
    },
    EMPLOYEE_SUMMARY: () => `/pms/employee-summary`,
    RM_SUMMARY: () => `/pms/rm-summary`,

    PMS_BUDGET_COUNT: (pmsYear, divisionHeadId, reviewerId, repManagerId) => {
      const queryParams = new URLSearchParams();
      if (pmsYear) queryParams.append("pmsYear", pmsYear);
      if (divisionHeadId) queryParams.append("divisionHeadId", divisionHeadId);
      if (reviewerId) queryParams.append("reviewerId", reviewerId);
      if (repManagerId) queryParams.append("repManagerId", repManagerId);
      const queryString = queryParams.toString();
      return queryString
        ? `/pms/getDHStatusCount?${queryString}`
        : `/pms/getDHStatusCount`;
    },
  },

  REPORTING_MANAGER: {
    FETCH_RM_ANALYTIC_CHART: "pms/rm-analytics-chart",
    FETCH_RM_DROPDOWN: "pms/as-repMan-dropdown",
    FETCH_RM_LIST: "pms/fetch-repMan-List",
  },
  REVIEWER: {
    FETCH_REVIEWER_ANALYTIC_CHART: "pms/chart/rev-dh-chart",
    FETCH_REVIEWER_DROPDOWN: "pms/as-reviewer-dropdown",
    FETCH_REVIEWER_LIST: "pms/fetch-reviewer-List",
  },
  DIVISIONHEAD: {
    SAMPLE_DOWNLOAD: "/pms/divisionHeadSampleFile",
    DHLIST: (pmsYear) => `/pmsDHTargetMaster/fetchDHList?pmsYear=${pmsYear}`,
    SAMPLE_DOWNLOAD: () => `/pmsDHTargetMaster/dhTargetSampleFile`,
    SAVE_BULK_UPLOAD: () => `/pms/HR/updateBulkUploadFileNew`,

    MASTER: (values) => {
      const ids = values.empId.map((id) => `id=${id}`).join("&");
      return `/pmsDHTargetMaster?pmsYear=${values.pmsYear}&target=${values.amount}&${ids}`;
    },
    BULK_UPLOAD: "/pms/divisionHeadUploadExcel",
    GET_ALLOCATION: (pmsYear) => `/pmsDHTargetMaster/list?pmsYear=${pmsYear}`,
    DH_BULK_UPLOAD: (pmsYear) =>
      `/pmsDHTargetMaster/bulkUploadDH?pmsYear=${pmsYear}`,
  },
  ASHR: {
    ASHR_UPDATE: (checkPromotionWeightage = 0) =>
      `/pms/HR/asHR/update?checkPromotionWeightage=${checkPromotionWeightage}`,
    ASHR_UPDATE_SAVE: (value, checkPromotionWeightage = 0) =>
      `/pms/HR/asHR/update?required=${value}&checkPromotionWeightage=${checkPromotionWeightage}`,
    EMP_HISTORY: (empId) => `/pms/HR/asBH/list?empId=${empId}`,
    EMP_TABLE_HISTORY: (empId) => `/pms/HR/pms-history?empId=${empId}`,
    ASHR_SAMPLEDOWNLOAD: (pmsYear, levelName) =>
      `/pms/HR/downloadSampleFileForBH?pmsYear=${pmsYear}&levelName=${levelName}`,
    // ASHR_BH_BULKUPLOAD: () => `/pms/HR/updateBulkUploadFile`,
    ASHR_BULKUPLOAD: "/pms/HR/updateBulkUploadFile",
    MANPOWER_BULKUPLOAD: "/pms/man-power/import",
    HR_BH_SAMPLE_DOWNLOAD: () => `/pms/HR/downloadSampleFileForBH`,
    MANPOWER_LIST: (empId, pmsYear) => {
      const params = new URLSearchParams();
      if (empId) params.append("empId", empId);
      if (pmsYear) params.append("pmsYear", pmsYear);
      return `/pms/man-power/list?${params.toString()}`;
    },
    RATING_PERCENTAGE_UPDATE: () => `api/pms/pmsRatingMaster/saveOrUpdate`,
    RATING_PERCENTAGE_GET: (pmsYear) => `/api/pms/pmsRatingMaster/${pmsYear}`,
    HR_SUMMARY: (pmsYear) => `/pms/HR/getHrSummary/${pmsYear}`,
    ASHR_DROPDOWN: (
      pmsYear,
      divHeadId,
      reviewerId,
      repManId,
      roleOfIntake,
      status,
      promotion,
    ) => {
      const queryParams = new URLSearchParams();
      queryParams.append("pmsYear", pmsYear);
      if (divHeadId) queryParams.append("divHeadId", divHeadId);
      if (reviewerId) queryParams.append("reviewerId", reviewerId);
      if (repManId) queryParams.append("repManId", repManId);
      if (roleOfIntake) queryParams.append("roleOfIntake", roleOfIntake);
      if (status) queryParams.append("status", status);
      if (promotion) queryParams.append("promotion", promotion);

      const queryString = queryParams.toString();
      return queryString
        ? `pms/HR/asHR/dropdown?${queryString}`
        : `/pms/HR/asHR/dropdown`;
    },
    MANPOWER_DROPDOWN: (
      pmsYear,
    ) => {
      const queryParams = new URLSearchParams();
      if (pmsYear) queryParams.append("pmsYear", pmsYear);
      const queryString = queryParams.toString();
      return queryString
        ? `/pms/man-power/dropdown-list?${queryString}`
        : `/pms/man-power/dropdown-list`;
    },
    ASHR_LIST: (
      level,
      repManId,
      reviewerId,
      divHeadId,
      empId,
      manPower,
      pmsYear,
      roleOfIntake,
      department,
      grade,
      pageNo,
      pageSize,
      status,
      promotion,
      qcStatus,
    ) => {
      const queryParams = new URLSearchParams();
      if (level) queryParams.append("level", level);
      if (repManId) queryParams.append("repManId", repManId);
      if (reviewerId) queryParams.append("reviewerId", reviewerId);
      if (divHeadId) queryParams.append("divHeadId", divHeadId);
      if (empId) queryParams.append("empId", empId);
      if (manPower) queryParams.append("manPower", manPower);
      if (pmsYear) queryParams.append("pmsYear", pmsYear);
      if (roleOfIntake) queryParams.append("roleOfIntake", roleOfIntake);
      if (department) queryParams.append("department", department);
      if (grade) queryParams.append("grade", grade);
      if (pageNo != null) queryParams.append("pageNo", pageNo);
      if (pageSize != null) queryParams.append("pageSize", pageSize);
      if (status) queryParams.append("status", status);
      if (promotion) queryParams.append("promotion", promotion);
      if (qcStatus) queryParams.append("qcStatus", qcStatus);

      const queryString = queryParams.toString();
      return queryString
        ? `/pms/HR/asHR/list?${queryString}`
        : `/pms/HR/asHR/list`;
    },
    PAYROLL_UPDATE: () => `/pms/HR/updateCTCBreakUps`,
    CTC_SPLIT_UP: () => `/pms/ctc/list`,
    UPDATE_CTC: (withEffectDate, type) =>
      `pms/HR/sync-payroll-ctc-to-pms?withEffectDate=${withEffectDate}&type=${type}`,
    PAYROLL_UPDATE_BUTTON: (pmsYear) =>
      `/pms/HR/payrollUpdateStatus/${pmsYear}`,
    HR_BUTTON_HANDLE: (pmsYear) => `/pms/HR/pmsOpenStatus/${pmsYear}`,
    CTC_SAMPLE_DOWNLOAD: "/pms/HR/CTCBreakup/downloadPmsCTCBreakUpSampleFile",

    BULK_UPLOAD: "/pms/HR/CTCBreakup/uploadPmsCTCBreakUp",
    UPDATE_REVISEDCTC_TO_QC: "/pms/payroll-status/update",

    REVISED_CTC_LIST: (
      level,
      repManId,
      reviewerId,
      divHeadId,
      empId,
      manPower,
      pmsYear,
      roleOfIntake,
      department,
      grade,
      payrollSubmitStatus,
    ) => {
      const queryParams = new URLSearchParams();
      if (level) queryParams.append("levelName", level);
      if (repManId) queryParams.append("repManagerId", repManId);
      if (reviewerId) queryParams.append("reviewerId", reviewerId);
      if (divHeadId) queryParams.append("divisionHeadId", divHeadId);
      if (empId) queryParams.append("employeeId", empId);
      if (manPower) queryParams.append("manPower", manPower);
      if (pmsYear) queryParams.append("pmsYear", pmsYear);
      if (roleOfIntake) queryParams.append("payrollStatus", roleOfIntake);
      if (department) queryParams.append("department", department);
      if (grade) queryParams.append("grade", grade);
      if (payrollSubmitStatus)
        queryParams.append("payrollSubmittedStatus", payrollSubmitStatus);
      const queryString = queryParams.toString();
      return queryString ? `/pms/HR/listAll?${queryString}` : `/pms/HR/listAll`;
    },
    CONVERSION_LIST: (pmsYear, roleOfIntake) => {
      const queryParams = new URLSearchParams();

      if (pmsYear) queryParams.append("pmsYear", pmsYear);
      if (roleOfIntake) queryParams.append("payrollStatus", roleOfIntake);

      const queryString = queryParams.toString();
      return queryString
        ? `/pms/payroll-status/onroll-conversion/list?${queryString}`
        : `/pms/payroll-status/onroll-conversion/list
 `;
    },
    OCR_LIST: (pmsYear) => {
      const queryParams = new URLSearchParams();

      if (pmsYear) queryParams.append("pmsYear", pmsYear);

      const queryString = queryParams.toString();
      return queryString
        ? `/pms/OCR/list?${queryString}`
        : `/pms/OCR/list
 `;
    },
    CTC_BREAKUP: (level, pmsYear, page, pageSize) => {
      const queryParams = new URLSearchParams();
      if (level) queryParams.append("levelName", level);
      if (pmsYear) queryParams.append("pmsYear", pmsYear);
      if (page != null) queryParams.append("page", page);
      if (pageSize) queryParams.append("size", pageSize);
      const queryString = queryParams.toString();
      return queryString ? `/pms/HR/list?${queryString}` : `/pms/HR/list`;
    },
    CTC_LIST: (
      level,
      repManId,
      reviewerId,
      divHeadId,
      empId,
      manPower,
      pmsYear,
      roleOfIntake,
      department,
      grade,
      page,
      size,
    ) => {
      const queryParams = new URLSearchParams();
      if (level) queryParams.append("levelName", level);
      if (repManId) queryParams.append("repManagerId", repManId);
      if (reviewerId) queryParams.append("reviewerId", reviewerId);
      if (divHeadId) queryParams.append("divisionHeadId", divHeadId);
      if (empId) queryParams.append("employeeId", empId);
      if (manPower) queryParams.append("manPower", manPower);
      if (pmsYear) queryParams.append("pmsYear", pmsYear);
      if (roleOfIntake) queryParams.append("payrollStatus", roleOfIntake);
      if (department) queryParams.append("department", department);
      if (grade) queryParams.append("grade", grade);
      if (page != null) queryParams.append("page", page);
      if (size != null) queryParams.append("size", size);

      const queryString = queryParams.toString();
      return queryString ? `/pms/HR/list?${queryString}` : `/pms/HR/list`;
    },
    CTC_DROPDOWN: () => `/pms/HR/ctc-dropdown`,

    CTC_EXPORT: (pmsYear) => {
      const queryParams = new URLSearchParams();
      if (pmsYear) queryParams.append("pmsYear", pmsYear);
      const queryString = queryParams.toString();
      return queryString
        ? `/pms/HR/list-export?${queryString}`
        : `/pms/HR/list-export`;
    },
    DH_ANALYTICS_REPORT: (
      level,
      pmsYear,
      divHeadId,
      reviewerId,
      repManId,
      grade,
    ) => {
      const queryParams = new URLSearchParams();
      if (level) queryParams.append("level", level);
      if (pmsYear) queryParams.append("pmsYear", pmsYear);
      if (divHeadId) queryParams.append("divHeadId", divHeadId);
      if (reviewerId) queryParams.append("reviewerId", reviewerId);
      if (repManId) queryParams.append("repManId", repManId);
      if (grade) queryParams.append("grade", grade);
      const queryString = queryParams.toString();
      return queryString
        ? `/pms/HR/analytics/fetchDhAnalytics?${queryString}`
        : `/pms/HR/analytics/fetchDhAnalytics`;
    },
    FETCH_ANALYTICS_REPORT: (
      pmsYear,
      divHeadId,
      reviewerId,
      repManId,
      grade,
    ) => {
      const queryParams = new URLSearchParams();
      if (pmsYear) queryParams.append("pmsYear", pmsYear);
      if (divHeadId) queryParams.append("divHeadId", divHeadId);
      if (reviewerId) queryParams.append("reviewerId", reviewerId);
      if (repManId) queryParams.append("repManId", repManId);
      if (grade) queryParams.append("grade", grade);
      const queryString = queryParams.toString();
      return queryString
        ? `/pms/HR/analytics/fetch?${queryString}`
        : `/pms/HR/analytics/fetch`;
    },
  },
  ORG: {
    ORG_MAIL_SEND: () => `/pms/HR/orgLevel/update`,
    ORG_MANUAL_MAIL_SEND: () => `pms/HR/manual-mail-trigger`,
    ORG_COUNT:() =>`/pms/HR/org-mail-status-count`,
    ORG_PEDNING_COUNT:() =>`/pms/QC/pendingMailEmployees`,
    ORG_MANUAL_UPLOAD:() =>`/pms/QC/hrUploadQCLetters`,
    ORG_LIST: (
      level,
      pmsYear,
      divisionHeadId,
      reviewerId,
      repManagerId,
      empId,
      department,
      roleOfIntake,
      grade,
      mailStatus,
      manualMailStatus,
      promotionType,
      manPower,
      pageNo,
      pageSize,
    ) => {
      const queryParams = new URLSearchParams();
      if (level) queryParams.append("level", level);
      if (pmsYear) queryParams.append("pmsYear", pmsYear);
      if (divisionHeadId) queryParams.append("divisionHeadId", divisionHeadId);
      if (reviewerId) queryParams.append("reviewerId", reviewerId);
      if (repManagerId) queryParams.append("repManagerId", repManagerId);
      if (empId) queryParams.append("empId", empId);
      if (department) queryParams.append("department", department);
      if (roleOfIntake) queryParams.append("roleOfIntake", roleOfIntake);
      if (grade) queryParams.append("grade", grade);
      if (mailStatus) queryParams.append("mailStatus", mailStatus);
      if (promotionType) queryParams.append("promotionType", promotionType);
      if (manPower) queryParams.append("manPower", manPower);
      if (manualMailStatus) queryParams.append("manualMailStatus", manualMailStatus);
      // if (pageNo) queryParams.append("pageNo", pageNo);
      // if (pageSize) queryParams.append("pageSize", pageSize);
      if (pageNo != null) queryParams.append("pageNo", pageNo);
      if (pageSize != null) queryParams.append("pageSize", pageSize);

      const queryString = queryParams.toString();
      return queryString
        ? `/pms/HR/orgLevel/fetch?${queryString}`
        : `/pms/HR/orgLevel/fetch`;
    },
    ORG_LETTER_PREVIEW: (pmsYear, empId) =>
      `pms/HR/orgLevel/qc-all-ctcLetter?pmsYear=${pmsYear}&empId=${empId}`,
  },

  QC: {
    QC_LIST: (
      level,
      pmsYear,
      divHeadId,
      reviewerId,
      repManId,
      empId,
      department,
      roleOfIntake,
      grade,
      manPower,
      qcStatus,
      pageNo,
      pageSize,
    ) => {
      const queryParams = new URLSearchParams();
      if (level) queryParams.append("level", level);
      if (pmsYear) queryParams.append("pmsYear", pmsYear);
      if (divHeadId) queryParams.append("divHeadId", divHeadId);
      if (reviewerId) queryParams.append("reviewerId", reviewerId);
      if (repManId) queryParams.append("repManId", repManId);
      if (empId) queryParams.append("empId", empId);
      if (department) queryParams.append("department", department);
      if (roleOfIntake) queryParams.append("roleOfIntake", roleOfIntake);
      if (grade) queryParams.append("grade", grade);
      if (manPower) queryParams.append("manPower", manPower);
      if (qcStatus) queryParams.append("qcStatus", qcStatus);
      if (pageNo !== undefined && pageNo !== null)
        queryParams.append("pageNo", pageNo);

      if (pageSize !== undefined && pageSize !== null)
        queryParams.append("pageSize", pageSize);

      const queryString = queryParams.toString();
      return queryString
        ? `/pms/QC/fetchList?${queryString}`
        : `/pms/QC/fetchList?`;
    },
    QC_LETTER_PREVIEW: (pmsYear, empId) =>
      `/pms/QC/qc-all-ctcLetter?pmsYear=${pmsYear}&empId=${empId}`,
    QC_UPDATE: "/pms/QC/updateQCLevel",
    QC_SAMPLE_DOWNLOAD: "/pms/QC/downloadSampleFile",
    QC_BULK_UPLOAD: "/pms/QC/updateBulkUploadFile",
    QC_OCR_COMPARE: "/pms/letter-qc/compare",
    QC_UPDATE_LETTER_STATUS: (pmsYear, empId) =>
      `/pms/QC/updateQCLetterStatus?pmsYear=${encodeURIComponent(pmsYear)}&empId=${encodeURIComponent(empId)}`,
  },

  OCR:{
    OCR_BULK_UPLOAD: "/pms/OCR/updateBulkUploadFile",
    OCR_UPDATE: "/pms/OCR/update",
    OCR_LIST: (pmsYear) => {
      const queryParams = new URLSearchParams();

      if (pmsYear) queryParams.append("pmsYear", pmsYear);

      const queryString = queryParams.toString();
      return queryString
        ? `/pms/OCR/list?${queryString}`
        : `/pms/OCR/list
 `;
    },
  },
  LTIP: {
    LTIP_SAMPLE_DOWNLOAD: "/pms/asHr/downloadLTIPSampleFile",
    LTIP_LIST: "/pms/fetch",
    LTIP_LETTER_PREVIEW: (pmsYear, empId) =>
      `/pms/hr-all-ltipLetter?pmsYear=${pmsYear}&empId=${empId}`,
    LTIP_BULK_UPLOAD: "/pms/updateEmployeeExcel",
    LTIP_UPDATE: "/pms/update",
    LTIP_DROPDOWN: (divHeadId, reviewerId, repManId) => {
      const queryParams = new URLSearchParams();
      if (divHeadId) queryParams.append("divHeadId", divHeadId);
      if (reviewerId) queryParams.append("reviewerId", reviewerId);
      if (repManId) queryParams.append("repManId", repManId);

      const queryString = queryParams.toString();
      return queryString
        ? `pms/ltip/dropdown?${queryString}`
        : `/pms/ltip/dropdown`;
    },
  },
  MASTER: {
    GET_ELIGIBLE_LIST: (filterData) =>
      `/pms/eligible-users?pageNo=${filterData.page}&pageSize=${filterData.per_page}&role=${filterData.role}&empId=${filterData.empId}&search=${filterData.search}&overView=${filterData.overview}`,
    DROPDOWN: (role) => `/pms/HRDashBoardDropDown?role=${role}`,
    ADD_ELIGIBLE_LIST: () => `/pms/updateEligibleStatus`,
    INELIGIBLE_LIST: () => `/pms/non-eligible-users`,
    LEVEL_DATE: () => `/pmsLevel/createPmsLevelByYear`,
    GET_LEVEL_DATE: (pmsYear) => `/pmsLevel/fetch-level-status?year=${pmsYear}`,
    PMS_START: (dates) =>
      `/pms/pmsOpen?selfStart=${dates.empStart}&selfEnd=${dates.empEnd}&rmStart=${dates.rmStart}&rmEnd=${dates.rmEnd}&revStart=${dates.revStart}&revEnd=${dates.revEnd}`,
    PMS_REMAINDER_EMAIL: (mailData) =>
      `/pms/HR/sendPmsReminder?pmsYear=${mailData.pmsYear}&endDate=${mailData.endDate}&levelName=${mailData.levelName}`,
    EXPORT: (filterData) =>
      `/pms/eligible-users/download?pmsRemoveStatus=${filterData.value}&levelName=${filterData.levelName}&id=${filterData.id}`,
    RATING_MASTER: () => `/pmsRatingWeightage/update-pms-rating-weightage`,
    GET_RATING_MASTER: (year) =>
      `pmsRatingWeightage/get-pms-rating-weightage?pmsYear=${year}`,
    SAVE_AS_DRAFT: (data) =>
      `/pms/save-as-draft?empId=${data.empId}&pmsYear=${data.pmsYear}`,
  },
};
